// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1ReQl","noInteraction":"EventWrapper_noInteraction__3nor_","pointerPassthrough":"EventWrapper_pointerPassthrough__1CLS9"};